module.exports = __webpack_public_path__ + "static/york_laptop-788e7103ee209db3ace911835f2e27b8.png";